import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ApiService } from 'src/app/services/api.service'

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccessDeniedComponent {
  // Only show "Go Back" if the user arrived from another page. document.referrer is empty
  // for fresh tabs (new-tab + typed URL, bookmarks, external no-referrer links) and is
  // preserved across location.replace(), so it stays set when handle-error.ts redirects here.
  // window.history.length is unreliable — Chrome counts the new-tab page, so it would be > 1
  // even in a "fresh tab" scenario where back would just return to chrome://newtab.
  hasHistory = document.referrer !== ''

  constructor(private apiService: ApiService) {}

  goBack() {
    window.history.back()
  }

  logout() {
    // Always redirect to / even if the logout API call fails — the user wants to leave,
    // and navigating to / will trigger re-auth if the session is still active.
    this.apiService.logout().subscribe({
      next: () => (window.location.href = '/'),
      error: () => (window.location.href = '/'),
    })
  }
}
